import { render, staticRenderFns } from "./BesoinsProtectionJuridique.vue?vue&type=template&id=73269276&scoped=true&"
import script from "./BesoinsProtectionJuridique.vue?vue&type=script&lang=js&"
export * from "./BesoinsProtectionJuridique.vue?vue&type=script&lang=js&"
import style1 from "./BesoinsProtectionJuridique.vue?vue&type=style&index=1&id=73269276&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73269276",
  null
  
)

export default component.exports